import React from "react";

interface SummaryTotalsProps {
  sumNetto?: number;
  sumBrutto?: number;
  tax?: number;
}

const format = (val?: number) =>
  String(val == null ? "0,0" : val.toFixed(2)).replace(".", ",");

const SummaryTotals: React.FC<SummaryTotalsProps> = ({ sumNetto, sumBrutto, tax }) => {
  return (
    <div className="summary-container">
      <div className="summary-title-mobile">Zusammenfassung:</div>
      <div className="summary-mobile-content">
        <div>{format(sumNetto)} € ohne MwSt.</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>+</span>
          <span>{format(tax)} € MwSt. 19%</span>
        </div>
        <div style={{ borderTop: "1px solid black", paddingTop: "4px", marginTop: "4px", fontWeight: "bold" }}>
          {format(sumBrutto)} € inkl. MwSt.
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          padding: "20px 20px 0 20px",
        }}
        className="summary-first-row"
      >
        <div style={{ width: "45%", color: "black" }} className="is-size-6 has-text-weight-bold"></div>
        <div style={{ width: "30%", color: "black", textAlign: "center", display: "flex", justifyContent: "space-around" }} className="is-size-6 has-text-weight-bold summary-title-desktop">
          <span style={{ fontWeight: "normal" }}>Zusammenfassung:</span>
        </div>
        <div style={{ width: "25%", color: "black", borderBottom: "black solid 1px", display: "flex" }} className="is-size-6 has-text-weight-bold summary-details">
          <div style={{ width: "20%", textAlign: "left", marginTop: "auto" }} className="summary-plus">+</div>
          <div style={{ width: "80%", textAlign: "right" }} className="summary-amounts">
            {format(sumNetto)} € ohne MwSt.
            <br />
            {format(tax)} € MwSt. 19%
          </div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-around",
          padding: " 0 20px 20px 20px",
        }}
        className="summary-second-row"
      >
        <div style={{ width: "10%", color: "black" }} className="is-size-6 has-text-weight-bold"></div>
        <div style={{ width: "15%", color: "black" }} className="is-size-6 has-text-weight-bold"></div>
        <div style={{ width: "60%", color: "black", textAlign: "center", display: "flex", justifyContent: "space-around" }} className="is-size-6 has-text-weight-bold"></div>
        <div style={{ width: "25%", color: "black", display: "flex" }} className="is-size-6 has-text-weight-bold summary-total">
          <div style={{ width: "20%", textAlign: "left", marginTop: "10%" }}></div>
          <div style={{ width: "80%", textAlign: "right" }}>{format(sumBrutto)} € inkl. MwSt.</div>
        </div>
      </div>
    </div>
  );
};

export default SummaryTotals;
